<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <v-layout pt-4 wrap justify-left>
      <v-flex xs12 xl11 px-2>
        <v-layout pt-3 wrap justify-start>
          <v-flex xs12 sm12  lg12 xl12>
            <v-layout wrap justify-space-between>
              <v-flex xs1 sm1 lg1 text-left align-self-center>
                <v-img
                  src="./../../../assets/Images/agogo.png"
                  contain
                  height="30px"
                ></v-img>
              </v-flex>
              <v-flex xs8 sm2 lg1 text-left align-self-center>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 18px;
                    color: #1c1c1c;
                  "
                >
                  Inventory
                </span>
                <!-- <span class="hidden-sm-and-up ibmbold appColor ">- {{ appCategory }}</span> -->
              </v-flex>
              <v-spacer class="hidden-xs-only"></v-spacer>
              <!-- <v-flex class="hidden-xs-only" xs3 py-2 py-sm-0 sm2 lg2 text-left px-2 align-self-center>
                <v-btn block dark color="#FC4B4B" depressed elevation="4" >
                  <span
                    :style="
                      $vuetify.breakpoint.name == 'xs'
                        ? 'font-family: poppinssemibold; font-size: 14px'
                        : 'font-family: poppinssemibold; font-size: 18px'
                    "
                  >
                    {{ appCategory }}
                  </span>
                </v-btn>
              </v-flex> -->
              <v-spacer class="hidden-xs-only"></v-spacer>
              <v-flex
                xs4
                sm4
                md3
                lg3
                text-left
                align-self-center
                px-12
                px-sm-6
                px-lg-12
                class="hidden-xs-only"
              >
                <v-select
                  outlined
                  dense
                  rounded
                  color="#FF1313"
                  placeholder="Product Status"
                  v-model="productStatus"
                  :items="productStatusList"
                  item-text="name"
                  item-value="val"
                  item-color="#FF1313"
                  hide-details
                  class="text-left"
                >
                  <template v-slot:item="{ item }">
                    <span class="poppinsregular text-left">
                      {{ item.name }}
                    </span>
                  </template>
                </v-select>
              </v-flex>
              <v-flex
                xs1
                lg3
                text-right
                align-self-center
                px-6
                px-sm-12
                class="hidden-sm-and-up"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon  class="align-center" v-bind="attrs" v-on="on">mdi-filter-variant</v-icon>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in productStatusList"
                      :key="index"
                    >
                      <v-list-item-title class="text-left" @click="getData(item.val)">{{ item.name }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start>
          <v-flex xs12 xl11>
            <SubCategorySlider />
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start v-if="productTotalCount > 0">
          <v-flex xs12 sm7 md5 lg5 xl4 text-left align-self-center>
            <v-layout wrap justify-start fill-height>
              <v-flex xs2 sm2 md2 lg2 xl2 pl-xl-4 text-left align-center>
                <span
                  style="
                    color: #8d8d8d;
                    font-family: opensansbold;
                    font-size: 14px;
                  "
                >
                  Status
                </span>
              </v-flex>
              <v-flex xs10 sm10 md10 lg10 xl10 text-left align-center>
                <v-radio-group v-model="listStatus" row>
                  <v-radio
                    value="Active"
                    class="mx-2"
                    :label="'Active (' + activeCount + ')'"
                    :ripple="false"
                    color="#5DC57C"
                  ></v-radio>
                  <v-radio
                    value="Inactive"
                    class="mx-2"
                    :label="'Inactive (' + inactiveCount + ')'"
                    :ripple="false"
                    color="#5DC57C"
                  ></v-radio>
                  <v-radio
                    value="All"
                    class="mx-2"
                    :label="'All (' + totalCount + ')'"
                    :ripple="false"
                    color="#5DC57C"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start v-if="products.length > 0">
          <template v-for="(item, i) in products">
            <v-flex xs12 xl11 :key="item._id" pr-lg-6 pr-xl-0>
              <InventoryItem v-bind:storage="item" @stepper="winStepper" />
            </v-flex>
            <v-flex xs12 xl11 :key="i" py-4>
              <v-divider></v-divider>
            </v-flex>
          </template>
        </v-layout>
        <v-layout wrap justify-center v-if="pages > 1">
          <v-flex xs12>
            <v-pagination
              v-model="currentPage"
              :length="pages"
              :total-visible="7"
              color="#FF0000"
            ></v-pagination>
          </v-flex>
        </v-layout>
        <v-layout
          wrap
          fill-height
          pt-3
          pt-sm-16
          justify-center
          v-if="products.length < 1"
        >
          <v-flex xs12>
            <span
              style="
                font-family: poppinsregular;
                font-size: 20px;
                color: #000000;
              "
            >
              Oops! No Products Found
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import SubCategorySlider from "./subCategorySlider";
import InventoryItem from "./inventoryItem";
export default {
  components: {
    SubCategorySlider,
    InventoryItem,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      currentPage: this.$route.query.page ? Number(this.$route.query.page) : 1,
      pages: 1,
      count: 10,
      productTotalCount: 0,
      products: [],
      activeCount: 0,
      inactiveCount: 0,
      totalCount: 0,
      productData: {},
      listStatus: "All",
      searchKey: null,
      colorr: null,
      color: null,
      productStatus: "",
      productStatusList: [
        {
          name: "All",
          val: "",
        },
        {
          name: "Pending",
          val: "pending",
        },
        {
          name: "Approved",
          val: "approved",
        },
        {
          name: "Rejected",
          val: "rejected",
        },
      ],
    };
  },
  computed: {
    appCategory() {
      return this.$store.state.category;
    },
  },
  watch: {
    productStatus() {
      this.getData(this.productStatus)
    },
    listStatus() {
      this.getData();
    },
    currentPage() {
      this.$router.push({
        path: "/Seller/Inventory",
        query: {
          page: this.currentPage,
        },
      });
    },
  },
  beforeMount() {
    this.getData();
  },
  methods: {
    winStepper(window_data) {
      if (window_data.getData) {
        this.getData();
      }
    },
    getData(status) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/seller/my/product/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          keyword: this.$route.query.searchKey,
          subcategoryId: this.$route.query.subcategory,
          count: this.count,
          page: this.$route.query.page,
          // keyword: this.$route.query.searchKey,
          // subcategory: this.$route.query.subcategory,
          productStatus: status,
          // count: this.count,
          // page: this.$route.query.page,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
            this.pages = response.data.pages;
            this.activeCount = response.data.activecount;
            this.inactiveCount = response.data.inactivecount;
            this.totalCount = response.data.totalcount;
            this.productTotalCount = response.data.totalcount;

            this.products = this.products.map((x) => {
              if (x.isColor) {
                x.colorDetails = x.colorDetails.map((y) => {
                  y.color = JSON.parse(y.color);
                  y.colorHex = y.color.toString(16);
                  y.colorHex = y.colorHex.substring(2);
                  y.colorHex = "#" + y.colorHex;
                  return y;
                });
              }
              return x;
            });

            // this.colorr = this.products
            // console.log("hxcolo=",this.colorr);
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
